import { Mesh, MeshLambertMaterial, SphereGeometry, Vector3 } from "three";
import { Config } from "../../Config/Config.js";
import { Consts } from "../../Utils/Consts.js";
import { RingTypeEnum } from "../../Models/RingModel.js";
import { LabelText } from "../Primitive/Label/LabelText.js";
import { Utils } from "../../Utils/Utils.js";
export class Mastertab extends Mesh {
    constructor(viewType) {
        super(Mastertab.geometry, Mastertab.material);
        this.name = "Mastertab";
        this.scale.divideScalar(1000);
        this.isDraggable = true;
        this.add(this.label = new LabelText({ viewType, anchor: new Vector3(5, 5, 0), labelParams: { text: "ROT" } }));
        this.label.label.material.depthTest = false;
        this.label.visible = false;
        this.bindEvent("onHover", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = [this]);
            this.label.visible = true;
        });
        this.bindEvent("onLeave", () => {
            const scene = Utils.getScene(this);
            scene?.outlinePass && (scene.outlinePass.selectedObjects = []);
            this.label.visible = false;
        });
        this.bindEvent("onDragMove", (e) => {
            e.preventDefault = true;
            // movement logic inside CalibrationEllipse.ts
        });
        // Default.scaleByScaleFactorLabel(this);
    }
    update(refRingType, secRingType) {
        if (refRingType && secRingType) {
            const distanceFromCenter = (this.parent.radius + (refRingType === RingTypeEnum.FootPlate ? 35 : 25)) / 1000;
            const rotation = this.parent.axialMastertabOffset + Math.PI + this.parent.axialTypeOffset;
            this.position.set(0, distanceFromCenter, 0).applyAxisAngle(Consts.planeNormal, rotation);
        }
    }
}
Mastertab.geometry = new SphereGeometry(3, 15, 15);
Mastertab.material = new MeshLambertMaterial({ color: Config.calib_mastertab_color });
//# sourceMappingURL=Mastertab.js.map